import { withAuthenticatedClientRequest } from "@/api/requestBuilder/withClientRequest";
import requests from "./requests";
import { ICallableRequestBuilder } from "@/api/requestBuilder/types";
import config from "@shared/config/client";

const sendInvitesToArtist =
  (request: ICallableRequestBuilder<void>) =>
  (artistId: string, orderIds: string | string[]) => {
    return request.call(
      `${config.apiUrl}/openToWork/sendInvitesToArtist/${artistId}`,
      (init) => ({
        ...init,
        method: "POST",
        headers: {
          ...init.headers,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          artOrderIds: orderIds,
        }),
      }),
    );
  };

const openToWorkStatusChange =
  (request: ICallableRequestBuilder<void>) => (isOpenToWork: boolean) => {
    return request.call(`${config.apiUrl}/openToWork/statusChange`, (init) => ({
      ...init,
      method: "PUT",
      headers: {
        ...init.headers,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        isOpenToWork: isOpenToWork,
      }),
    }));
  };
const clientRequests = {
  sendInvitesToArtist: withAuthenticatedClientRequest(sendInvitesToArtist),
  openToWorkStatusChange: withAuthenticatedClientRequest(
    openToWorkStatusChange,
  ),
  getOrdersForOpenToWorkArtists: withAuthenticatedClientRequest(
    requests.getOrdersForOpenToWorkArtists,
  ),
  getOpenToWorkArtists: withAuthenticatedClientRequest(
    requests.getOpenToWorkArtists,
  ),
};

export default clientRequests;
